import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classname';

const Union = ({ width, height, className, color, outline }) => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className={cls(className, 'icon icon-union')}
    width={width}
    height={height}
  >
    {outline ? (
      <g id="User">
        <path d="M21,30H11a5,5,0,0,1-5-5V24a9,9,0,0,1,9-9h2a9,9,0,0,1,9,9v1A5,5,0,0,1,21,30ZM15,17a7,7,0,0,0-7,7v1a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V24a7,7,0,0,0-7-7Z" fill={color} stroke={color}/>
        <path d="M16,14a6,6,0,1,1,6-6A6,6,0,0,1,16,14ZM16,4a4,4,0,1,0,4,4A4,4,0,0,0,16,4Z" fill={color} stroke={color}/>
      </g>
    ) : (
      <g id="User">
        <path d="M21,30H11a5,5,0,0,1-5-5V24a9,9,0,0,1,9-9h2a9,9,0,0,1,9,9v1A5,5,0,0,1,21,30ZM15,17a7,7,0,0,0-7,7v1a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V24a7,7,0,0,0-7-7Z" fill={'white'} stroke={'white'}/>
        <path d="M16,14a6,6,0,1,1,6-6A6,6,0,0,1,16,14ZM16,4a4,4,0,1,0,4,4A4,4,0,0,0,16,4Z" fill={'white'} stroke={'white'}/>
      </g>
    )}
    </svg>
);

Union.defaultProps = {
  width: 25,
  height: 24,
  color: '#6E7DAF',
  outline: null,
};

Union.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  color: PropTypes.string,
  outline: PropTypes.bool,
};

export default Union;
